import { OptionsSortType } from 'Core/interfaces'

import { defaultOptionsSorting, sortOptionsById, usaFirstOptionsSorting } from './sortHelpers'

export const OPTIONS_SORT_CONFIG: {
	[key in keyof typeof OptionsSortType]: (options: MainSearchOptions[]) => MainSearchOptions[]
} = {
	[OptionsSortType.default]: defaultOptionsSorting,
	[OptionsSortType.usaFirst]: usaFirstOptionsSorting,
	[OptionsSortType.byId]: sortOptionsById
}
